import AdministrationRouter from "./AdministrationRouter"

export default AdministrationRouter